import { Box } from "@mui/material";
import usePageTitle from "../../../../../Common/hooks/usePageTitle";
import { useToolsForSelect } from "../../../../../Common/hooks/useToolsForSelect";
import ProjectToolsForm from "../../../components/ProjectToolsForm/ProjectToolsForm";
import ProjectTabSkeleton from "../../../components/ProjectTabSkeleton/ProjectTabSkeleton";
import useProjectTools from "../../../hooks/useProjectTools";
import useProjectUserPermissions from "../../../hooks/useProjectUserPermissions";
interface ProjectToolsTabProps {
  userCanEdit: boolean;
  canManageAzureResources: boolean;
  canManageGithubRepositories?: boolean;
  id: string;
  packageId: string;
  projectName: string;
  useCustomRoleMapping: boolean;
}

const ProjectToolsTab = ({
  id,
  packageId,
  userCanEdit,
  canManageAzureResources,
  canManageGithubRepositories = false,
  projectName,
  useCustomRoleMapping,
}: ProjectToolsTabProps) => {
  usePageTitle("Project | Tools");
  const { projectTools, isLoading: isLoadingProjectTools } =
    useProjectTools(id);
  const { data: permissions, isLoading: isLoadingCurrentUserToolAccess } =
    useProjectUserPermissions(id);
  const toolIdsWithAccess = permissions?.accessToTools ?? [];

  const {
    optionalTools,
    tools: mandatoryTools,
    isLoading: isLoadingOptionalTools,
  } = useToolsForSelect(packageId);

  if (isLoadingProjectTools || isLoadingOptionalTools || isLoadingCurrentUserToolAccess) {
    return <ProjectTabSkeleton variant="tools" />;
  }

  return (
    <Box sx={{ pl: "80px", pt: "24px", height: "100%", minHeight: 0, position: "relative" }}>
      {projectTools && (
        <ProjectToolsForm
          projectTools={projectTools}
          mandatoryTools={mandatoryTools}
          optionalTools={optionalTools}
          userCanEdit={userCanEdit}
          canManageAzureResources={canManageAzureResources}
          canManageGithubRepositories={canManageGithubRepositories}
          projectName={projectName}
          useCustomRoleMapping={useCustomRoleMapping}
          currentUserToolIdsWithAccess={toolIdsWithAccess}
          isCurrentUserToolAccessLoading={isLoadingCurrentUserToolAccess}
        />
      )}
    </Box>
  );
};
export default ProjectToolsTab;
